import { CBadge, CCol, CContainer, CForm, CRow } from "@coreui/react";
import { Typography } from "@mui/material";
import React from "react";
import "./QuizComponent.css";

function MultipleChoiceSuperadmin({
  type,
  num,
  question,
  score,
  data,
  onAnswerChange,
  questionID,
  questionTypeID,
}) {
  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
  };

  const getStyle = (ans) => {
    if (ans.value === 1) {
      return {
        backgroundColor: "#28a745", // Green background
      };
    }
    return {};
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
              <Typography
                variant="question"
                component="div"
                gutterBottom
                sx={{ color: "primary.main", mb: 2 }}
              >
                {`Q${num + 1}. ${question}`}
              </Typography>
              <CForm>
                <ul>
                  <CRow xs={{ gutterY: 2 }}>
                    <CCol xs={12}>
                      <CRow xs={{ gutterY: 2 }}>
                        {data.map((ans) => (
                          <CCol xs={12} key={ans.answerId}>
                            <div
                              className="d-flex align-items-start"
                              style={{ paddingRight: "20px" }}
                            >
                              <input
                                disabled={type === "3" ? false : true}
                                className="form-check-input options"
                                type="radio"
                                name={`question-${questionID}`}
                                id={ans.answerId}
                                value={ans.answerId}
                                onChange={() =>
                                  handleSelectAnswer(ans.answerId)
                                }
                                style={{
                                  ...getStyle(ans),
                                  marginTop: "6px",
                                }}
                              />
                              <label
                                style={{
                                  marginLeft: "12px",
                                  flex: 1,
                                  lineHeight: "1.5",
                                }}
                                className="optionText"
                                htmlFor={ans.answerId}
                              >
                                {ans.label}
                              </label>
                            </div>
                          </CCol>
                        ))}
                      </CRow>
                    </CCol>
                  </CRow>
                </ul>
              </CForm>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge shape="rounded-pill" color="primary" className="badge">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default MultipleChoiceSuperadmin;
